var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',_vm._g(_vm._b({staticClass:"v-app-ad d-inline-flex flex-child-1 grow-shrink-0 my-2",style:(_vm.styles),attrs:{"rounded":"","width":"100%"}},'v-sheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }